import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import { groupBy } from 'remeda';

import { ShortcutText } from 'src/components/ShortcutText/shortcut-text';
import { appShortcuts } from 'src/constants/appShortcuts';
import { SearchBar } from 'src/pages/Search/search-bar';
import { Modals, useModalMethods } from 'src/store/modals';

export const ShortcutsModal = () => {
  const { closeModal } = useModalMethods(Modals.ShortcutsModal);
  const [searchTerm, setSearchTerm] = useState('');

  const filteredShortcuts = Object.entries(
    groupBy(
      Object.values(appShortcuts).filter(
        (shortcut) =>
          shortcut.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          shortcut.command.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
      (shortcut) => shortcut.categoryName || '',
    ),
  );

  return (
    <Dialog open onClose={closeModal} fullWidth>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderColor: (theme) => theme.palette.custom.OV.sys.outlineVariant,
          px: 3,
        }}
      >
        <Typography>Keyboard Shortcuts</Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 3,
        }}
      >
        <SearchBar onSearch={setSearchTerm} placeholder="Search shortcuts" />
        <Stack
          sx={{
            minHeight: 400,
            maxHeight: 400,
            overflowY: 'auto',
          }}
        >
          {filteredShortcuts.map(([category, items]) => (
            <Stack key={category} spacing={1} mt={2}>
              <Typography variant="subtitle2">{category}</Typography>
              {items.map((shortcut) => (
                <Stack
                  key={shortcut.command}
                  alignItems="space-between"
                  direction="row"
                  sx={{ pr: 1 }}
                >
                  <Typography
                    variant="subtitle2"
                    flexGrow={1}
                    sx={{ fontSize: '0.85rem', fontWeight: '400' }}
                  >
                    {shortcut.description}
                  </Typography>
                  <ShortcutText shortcut={shortcut.command} />
                </Stack>
              ))}
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
        }}
      >
        <Button onClick={closeModal}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
